exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mat-dialog-actions {\n  margin-top: 30px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/app/components/settings-dialog/settings-dialog.component.scss
// module id = ../../../../../src/app/components/settings-dialog/settings-dialog.component.scss
// module chunks = main